import { loadIntent } from "@/contexts/PendingIntentContext";

const isConnectionPath = (path: unknown) => typeof path === "string" &&
  ["/connect/chatgpt", "/connections/chatgpt"].includes(path.split(/[?#]/)[0].replace(/\/$/, ""));

// OAuth arrives through a full-page redirect. Account switching reloads /login;
// the existing pending intent preserves its return journey across that reload.
// Keep telemetry disabled for the document lifetime even after consuming it.
export const IS_CONNECTION_SESSION = typeof window !== "undefined" &&
  (isConnectionPath(window.location.pathname) || isConnectionPath(loadIntent()?.returnPath));
